import { createContext } from 'react';

export const RestaurantMenuContext = createContext({});